/* eslint-disable @typescript-eslint/no-floating-promises */
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'
import { IStackedColumnChartData } from '../ColumnStacked'

interface iProps {
  id: string
  data: IStackedColumnChartData
}

export const ColumnChart: React.FC<iProps> = ({ id, data }) => {
  function getSeries(): ApexAxisChartSeries {
    return [
      {
        name: 'Valores',
        data: data.seriesEscala
      }
    ]
  }

  function GerarGrafico(): void {
    const options: ApexCharts.ApexOptions = {
      series: getSeries(),
      chart: {
        height: 350,
        width: '100%',
        type: 'bar'
      },
      colors: ['var(--v2)'],
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: (value: number): string => {
          if (isNaN(value) || value === undefined) return '0'
          return `${value}`
        },
        offsetY: -20,
        style: {
          fontSize: '10px',
          colors: ['#000']
        }
      },
      legend: {
        show: false
      },
      xaxis: {
        categories: data.dates,
        labels: {
          style: {
            fontSize: '10px'
          }
        }
      },
      yaxis: {
        show: false
      }
    }

    const chart = new ApexCharts(document.querySelector(`#chart-${id}`), options)
    chart.render()
    chart.updateSeries(getSeries())
  }

  useEffect(() => {
    GerarGrafico()
  }, [data])

  return <div style={{ width: '100%' }} id={`chart-${id}`} />
}
